import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {PolygonService} from "../../../service-areas/services/polygons-service.service";
import {MapsCommonService} from "../../../map/services/mapsCommon.service";
import {escapeHtml} from "../../../commons/utils/html-escape.util";

export class ServiceMapCtrl implements IController {
  service: any;
  serviceAreas: any;
  addMarkerEnabled: any;
  showHistory: boolean;
  agent: any;
  selectedAction: any;
  onLocationSelect: Function;

  private readonly mapTypeIds: any;

  private circleTypes: any;
  private agentActionsControl: any;
  private taskMarkerIcons: any;
  private agentActionMarkers: any;
  private infowindow = new google.maps.InfoWindow()
  private map: any;
  private filters: any;
  private markerEvents: any;
  private agentMarker: any;
  private circles: any;
  private mapServiceAreas: any;
  public polygonEvents: any;

  /* @ngInject */
  constructor(private mapsCommonService: MapsCommonService, private uiGmapIsReady, private tasksConstants, private polygonService: PolygonService) {
    this.mapTypeIds = {
      roadmap: 'ROADMAP',
      satellite: 'SATELLITE'
    };
    this.agentMarker = {
      options: {
        icon: undefined,
        visible: true
      }
    };
    this.agentActionsControl = {};
  }

  $onInit() {
    this.taskMarkerIcons = {};
    this.agentActionMarkers = [];
    this.infowindow.setOptions({disableAutoPan: true})

    this.filters = {
      serviceAreas: false,
      satellite: false,
      geofencing: false
    };

    this.markerEvents = {
      position_changed: (marker, event, model, args) => {
        this.setMapBounds();
      }
    };

    this.map = {
      zoom: 14,
      center: this.mapsCommonService.getSiteLocation(),
      options: {
        styles: this.mapsCommonService.getDefaultStyle(),
        mapTypeControl: false,
        maxZoom: 18,
        scaleControl: true,
        mapTypeId: google.maps.MapTypeId[this.mapTypeIds.roadmap]
      },
      events: {
        click: (map, eventType, event) => {
          if (this.addMarkerEnabled) {
            const lat = event[0].latLng.lat();
            const lng = event[0].latLng.lng();
            this.onLocationSelect({location: {lat: lat, lng: lng}});
          }
        }
      }
    };

    this.uiGmapIsReady.promise(1).then(() => {
      this.setMapBounds();
    });

    this.taskMarkerIcons = this._setMarkers();

    this.polygonEvents = {
      mouseover: (marker, event, model) => {
        const map = marker.map;
        const contentString =
          '<div style="text-align: center; width: 100%">' + escapeHtml(_.get(model, 'fill.name')) + '</div>';
        this.infowindow.setPosition(this.mapsCommonService.getPolygonBounds(model.path).getCenter());
        this.infowindow.setContent(contentString);
        this.infowindow.open(map, marker);
      },
      mouseout: () => {
        this.infowindow.close();
      }
    };

    if (this.showHistory) {
      this.agentActionMarkers = this._setActionMarkers();
    }

    //Set geofencing Circles
    this.onGeofancingChange(this.filters.geofencing);

    this._setMapServiceAreas(this.serviceAreas);

    this.setMapBounds();

  }

  $onChanges(changes) {
    if (changes.service && !changes.service.isFirstChange()) {
      this.setMapBounds();
    }

    if (changes.serviceAreas && !changes.serviceAreas.isFirstChange()) {
      this._setMapServiceAreas(this.serviceAreas);
    }

    // if (changes.selectedAction && !changes.selectedAction.isFirstChange()) {
    //   this.agentActionMarkers = this._setActionMarkers();
    //   // if (this.agentActionsControl) {
    //   //   const markers = this.agentActionsControl.getGMarkers();
    //   //
    //   //   _.forEach(markers, (m) => {
    //   //     const status = 'Courier' + history.courierAction.action;
    //   //     const isSelected = _.get(m, 'model.id', m.key) === this.selectedAction.ts;
    //   //     const color = isSelected ? '#FFEB3B' : '#7E7E7E';
    //   //     m.setIcon(this.mapsCommon.getTaskMarkerIcon(undefined, status, isSelected, color));
    //   //   });
    //   // }
    // }

    if ((changes.showHistory && !changes.showHistory.isFirstChange()) ||
      (changes.selectedAction && !changes.selectedAction.isFirstChange())) {
      this.agentActionMarkers = !!this.showHistory ? this._setActionMarkers() : [];
    }

    if (changes.agent) {
      const currentAgent = changes.agent.currentValue,
        previousAgent = changes.agent.previousValue;

      if (!!currentAgent) {
        this.circleTypes = this.mapsCommonService.getTasksRadiusPayload(currentAgent);
      }

      this.agentMarker.options.icon = this.agent ? this.mapsCommonService.getAgentIcon(this.agent) : undefined;

      // if (_.get(currentAgent, 'lastKnownLocation.coordinates') && !_.get(previousAgent, 'lastKnownLocation.coordinates')) {
      //   this.setMapBounds();
      // }
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onMapTypeChange(isSatelliteEnabled) {
    this.map.options.mapTypeId = google.maps.MapTypeId[isSatelliteEnabled ? this.mapTypeIds.satellite : this.mapTypeIds.roadmap];
  }

  onToggleServiceAreas(isEnabled) {
    this._setMapServiceAreas(this.serviceAreas);
  }

  onGeofancingChange(isEnabled) {
    this.circles = [];
    if (isEnabled) {

      _.forEach(this.service.taskList, (t) => {
        const taskCircles = angular.copy(this.circleTypes);

        taskCircles[0].center = t.taskSpec.address.location;
        taskCircles[1].center = t.taskSpec.address.location;
        this.circles = this.circles.concat(taskCircles);
      })

    }
  }

  setMapBounds() {
    if (this.service) {
      var markers = this._getTasksMarkersWithLocation(this.service.taskList);

      if (_.get(this.agent, 'lastKnownLocation.coordinates')) {
        var agentMarker: any = new google.maps.MVCObject();
        agentMarker.set('coords', {
          'latitude': this.agent.lastKnownLocation.coordinates.latitude,
          'longitude': this.agent.lastKnownLocation.coordinates.longitude
        });
        markers.push(agentMarker);
      }

      if (_.get(this.service, 'history')) {
        _.forEach(this.service.history, (history) => {
          if (!_.get(history, 'courierAction.manual') && _.get(history, 'courierAction.location')) {
            const marker: any = {};
            _.set(marker, 'coords', {
              'latitude': history.courierAction.location.latitude,
              'longitude': history.courierAction.location.longitude,
              'lat': history.courierAction.location.lat,
              'lng': history.courierAction.location.lng
            })
            markers.push(marker);
          }
        })
      }

      if (markers.length) {
        this.mapsCommonService.centerMapByBounds(this.map, markers);
      }
    }
  }

  private _getTasksMarkersWithLocation(tasks) {
    return _.chain(tasks)
      .filter((t) => {
        return !!t.taskSpec.address.location;
      })
      .map((filteredTask) => {
        return {
          coords: filteredTask.taskSpec.address.location
        }
      })
      .value();
  }

  private _setMarkers() {
    var purposes = Object.keys(this.tasksConstants.purposeToServiceType);
    var taskMarkerIconsRef = {};

    _.forEach(purposes, (p) => {
      var icon = this.mapsCommonService.getTaskMarkerIcon(p);
      _.set(taskMarkerIconsRef, p, icon);
    });

    return taskMarkerIconsRef;
  }

  private _setMapServiceAreas(serviceAreas) {
    if (!this.filters.serviceAreas || !serviceAreas) {
      serviceAreas = [];
    }
    // const serviceAreasPolygons = this.PolygonService.getFeatures(serviceAreas);
    this.mapServiceAreas = this.mapsCommonService.buildPolygons(serviceAreas, true);
  }

  private _setActionMarkers() {
    const agentActionMarkersRef = [];

    if (_.get(this.service, 'history.length')) {
      _.forEach(this.service.history, (history) => {
        const coords = _.get(history.courierAction, 'location');

        if (!coords) {
          return;
        }

        const status = 'Courier' + history.courierAction.action;
        const isSelected = _.isEqual(history.ts, _.get(this.selectedAction, 'ts'));
        const actionId = history.ts;
        const color = isSelected ? '#e1e100' : '#7E7E7E'
        const marker = this.mapsCommonService.buildLocationMarker(actionId, coords, status, isSelected, color);

        agentActionMarkersRef.push(marker);
      });

      return agentActionMarkersRef;
    }

  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceMap', {
    bindings: {
      service: '<',
      serviceAreas: '<?',
      addMarkerEnabled: '<',
      showHistory: '<?',
      agent: '<?',
      selectedAction: '<?',
      onLocationSelect: '&'
    },
    template: require('./service-map.html').default,
    controller: ServiceMapCtrl
  });
